import { SVGProps } from 'react';
const SvgArrowUpMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 19V5M6 11l6-6 6 6"
    />
  </svg>
);
export default SvgArrowUpMd;
